/**
 * RCRA site-manager access for an EPA ID, as tracked in eManifestSiteSync by
 * the daily e-manifest-site-access sweep. Mirrors the GraphQL
 * SiteManagerAccessStatus enum values so API, Oak, and export lambdas share
 * one vocabulary:
 * - GRANTED: our RCRAInfo API user holds active SiteManagement permission.
 * - NONE: the sweep probed the site and we have no access.
 * - UNKNOWN: never probed (no sync row) or no EPA ID.
 */
export type SiteManagerAccessStatusValue = "GRANTED" | "NONE" | "UNKNOWN";

export const SITE_MANAGER_ACCESS_STATUS_VALUES: SiteManagerAccessStatusValue[] = [
  "GRANTED",
  "NONE",
  "UNKNOWN",
];

export const siteManagerAccessStatusFromHasSiteAccess = (
  hasSiteAccess: boolean | null | undefined
): SiteManagerAccessStatusValue => {
  if (hasSiteAccess === true) return "GRANTED";
  if (hasSiteAccess === false) return "NONE";
  return "UNKNOWN";
};

const SITE_MANAGER_ACCESS_STATUS_LABELS: Record<SiteManagerAccessStatusValue, string> = {
  GRANTED: "Granted",
  NONE: "No access",
  UNKNOWN: "Not determined",
};

export const siteManagerAccessStatusToLabel = (status: string | null | undefined): string => {
  if (status === "GRANTED" || status === "NONE" || status === "UNKNOWN") {
    return SITE_MANAGER_ACCESS_STATUS_LABELS[status];
  }
  return SITE_MANAGER_ACCESS_STATUS_LABELS.UNKNOWN;
};
